import { FeatureFlag } from '@ps/web-core-enums';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import useFeature from '@swf/core/hooks/useFeature';

import useCheckUserClubRole from '../../../hooks/useCheckUserClubRole';
import { useHomeGamesWidget } from '../../../model';
import { UserClubRole } from '../../../types/common';
import type { Props } from '../Container';

import CloseOrLeaveClub from './CloseOrLeaveClub/CloseOrLeaveClub';
import ClubPrivacy from './ClubPrivacy/ClubPrivacy';
import ClubSeason from './ClubSeason/ClubSeason';
import DeleteClub from './DeleteClub/DeleteClub';
import EmailNotifications from './EmailNotifications/EmailNotifications';
import styles from './shared.scss';

const Settings: React.FC<Props> = () => {
  const { widgetDispatch } = useHomeGamesWidget();
  const { clubId } = useParams<{ clubId: string }>();
  const isManager = useCheckUserClubRole(clubId, [UserClubRole.Manager]);
  const canLeave = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Member]);
  const showClubPrivacy = useFeature(FeatureFlag.PKRHomeGamesPublicClubs);

  useEffect(() => {
    widgetDispatch.clubOptions({ clubId: Number(clubId) });
  }, [clubId, widgetDispatch]);

  return (
    <section className={styles.container}>
      <EmailNotifications />
      {canLeave && <CloseOrLeaveClub />}
      {isManager && (
        <>
          {showClubPrivacy && <ClubPrivacy />}
          <ClubSeason />
          <DeleteClub />
        </>
      )}
    </section>
  );
};

export default Settings;
